import { Truck, Wrench, Compass, Scissors, SquareParking, CreditCard } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { SERVICES, SERVICES_INTRO } from "../data/site";

const icons = {
  truck: Truck,
  wrench: Wrench,
  compass: Compass,
  scissors: Scissors,
  parking: SquareParking,
  card: CreditCard,
};

export const Services = () => (
  <section id="szolgaltatasok" data-testid="services-section" className="scroll-mt-24 py-24 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHeading eyebrow={SERVICES_INTRO.eyebrow} title={SERVICES_INTRO.title} />

      <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((s, i) => {
          const Icon = icons[s.icon];
          return (
            <Reveal key={s.title} delay={(i % 3) * 0.08}>
              <div
                data-testid={`service-card-${i}`}
                className="h-full rounded-3xl border border-line bg-white p-8 card-shadow transition-transform duration-300 hover:-translate-y-1"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-burgundy/10 text-burgundy">
                  <Icon className="h-[22px] w-[22px]" />
                </span>
                <h3 className="mt-5 font-display text-xl font-semibold text-ink">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-soft">{s.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
